module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.valid) ? _c('picture', {
    class: _vm.className
  }, [_vm._l((_vm.sizes), function(size, key) {
    return [(_vm.sizes[key]) ? _c('source', {
      attrs: {
        "srcset": _vm.imgset.sizes[key],
        "media": size
      }
    }) : _vm._e()]
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.defaultImage,
      "width": _vm.imgset.attributes.width,
      "height": _vm.imgset.attributes.height,
      "alt": _vm.imgset.attributes.alt
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37c29a6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VuePicture.vue
// module id = 43
// module chunks = 0